import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/users/reducers/userProfileReducer';
import appStateReducer from '../reducers/appStateReducer';

const store = configureStore({
    reducer: {
        userProfile: userReducer,
        appState: appStateReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
